module.exports = __webpack_public_path__ + "img/gold.fd760a48.svg";